export default "/public/app-main/static/image/e6d340fa0d88207fa23afa4230e78375.png";